<template>
  <div class="top-level-col" :style="colData.style" :class="[activeClass.value, {columnActive: columnActive === colIndex}]" :id="'col-' + conIndex+ '-' + colIndex">
    <div>
        <div class="header-action">
            <div class="my-btn-group">
                <b-button-group class="but-group inactive">
                    <b-button
                            @click="showColonneSize = !showColonneSize"
                            v-b-popover.hover.bottom="'Redimensionner la colonne'"
                    >{{ activeClass.display }}</b-button>
                    <b-button
                            @click="deleteColonne"
                    ><font-awesome-icon :icon="['fas', 'trash-alt']" /></b-button>
                              <b-button
                                      @click="activateColumn(colIndex)"
                              ><font-awesome-icon :icon="['fas', 'edit']" /></b-button>
                    <b-button  class="move-action" v-b-popover.hover.top="'Déplacer la colonne'"><font-awesome-icon :icon="['fas', 'expand-arrows-alt']" /></b-button>
                </b-button-group>
            </div>
        </div>
        <div class="container-controls d-none" :id="'control-' + conIndex+ '-' + colIndex">
            <ul>
                <li>
                    <b-button @click="handleAddElement('text')" class="btn-item">
                        <icon-base iconName="text" />
                    </b-button>
                </li>
                <li>
                    <b-button class="btn-item" @click="handleAddElement('drop')">
                        <font-awesome-icon :icon="['fas', 'table']" />
                    </b-button>
                </li>
                <li>
                    <b-button class="btn-item" @click="handleAddElement('logo')">
                        <font-awesome-icon :icon="['fas', 'image']" />
                    </b-button>
                </li>
                <li>
                    <b-button class="btn-item" @click="handleAddElement('image')">
                        <font-awesome-icon :icon="['fas', 'file-image']" />
                    </b-button>
                </li>

            </ul>
        </div>
        <div class="colonne" >
            <div  v-if="colData.childElements.length > 0">
                <colonneSize
                        :activeCol="activeClass.display"
                        :colClasses="colClasses"
                        @resizeCol="handleResizeCol"
                        v-if="showColonneSize"></colonneSize>

                <list-element
                        :elements="colData.childElements"
                        :col-index="colIndex"
                        :con-index="conIndex"
                ></list-element>

<!--                      <button-->
<!--                        @click="openElementSelectionModal"-->
<!--                        class="add-element">-->
<!--                        <font-awesome-icon :icon="['fas', 'plus']" /> Elément-->
<!--                      </button>-->
<!--                <selectionElement-->
<!--                        @addElement="handleAddElement"-->
<!--                        ref="selectionElement"-->
<!--                ></selectionElement>-->
<!--                <edit-wrapper-->
<!--                        @wrapperUpdate="handleWrapperUpdate"-->
<!--                        ref="editColWrapper"-->
<!--                />-->
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import colonneSize from './colonneSize'
import selectionElement from '../modal/selectionElement'
import elementText from './elementText'
import elementDrop from './elementDrop'
import listElement from './listElement'
// import editWrapper from '../modal/editWrapper'
import { mapActions } from 'vuex'
import iconBase from '../../icons/iconBase'
import {eventBus} from '../../../main'
export default {
  components: {
    colonneSize,
    selectionElement,
    elementText,
    elementDrop,
    listElement,
    iconBase
  },
  props: {
    colData: {
      type: Object,
      default: () => ({})
    },
    colIndex: Number,
    conIndex: Number
  },
  created () {
    eventBus.$on('setColumnStyle', (data) => {
      // console.log(data.containerIndex)
      // console.log(data.colIndex)
      // console.log(JSON.parse(JSON.stringify(data.style) ))
      var styles = JSON.parse(JSON.stringify(data.style))

      for (var key in styles) {
        document.getElementById('col-' + data.containerIndex + '-' + data.colIndex).style[key] = styles[key]
      }

      // setTimeout(() => {
      //     eventBus.$emit('selected', {
      //         containerId: this.conIndex,
      //         columnIndex: this.colIndex,
      //         element: this.colData,
      //         type: 'colonne'
      //     })
      // }, 500)

      this.handleWrapperUpdate(data)
    })
  },
  data () {
    return {
      columnActive: -1,
      colClasses: [
        {
          value: 'col-3',
          display: '1/4'
        },
        {
          value: 'col-6',
          display: '1/2'
        },
        {
          value: 'col-9',
          display: '3/4'
        },
        {
          value: 'col-12',
          display: '1/1'
        },
        {
          value: 'col',
          display: 'auto'
        }
      ],
      showColonneSize: false,
      colStyles: []
    }
  },
  computed: {
    activeClass () {
      let active = null
      this.colClasses.forEach(el => {
        if (el.value === this.colData.class) {
          active = { value: el.value, display: el.display }
        }
      })
      return active || { value: 'col', display: 'auto' }
    }
  },
  methods: {
    ...mapActions(['deleteFicheColonne', 'resizeFicheColonne', 'addFicheColonneElement', 'editFicheColonneTextElement', 'deleteFicheColonneTextElement', 'editFicheColonneDropElement', 'setAddedToFiche', 'updateColonne']),
    activateColumn (colIndex) {
      let allCols = document.querySelectorAll('.top-level-col')

      for (var i = 0; i < allCols.length; i++) {
        allCols[i].classList.remove('columnActive')
      }

      var resetImageActions = document.querySelectorAll('.for-image')

      for (var i = 0; i < resetImageActions.length; i++) {
        resetImageActions[i].classList.add('d-none')
      }

      let letAllContainers = document.querySelectorAll('[role="conteneur"]')

      for (var i = 0; i < letAllContainers.length; i++) {
        letAllContainers[i].classList.remove('container-active')
      }

      var containerControls = document.querySelectorAll('.container-controls')
      for (let j = 0; j < containerControls.length; j++) {
        containerControls[j].classList.add('d-none')
      }

      var cedit = document.querySelectorAll('.cedit')

      if (cedit.length > 0) {
        for (var j = 0; j < cedit.length; j++) {
          cedit[j].classList.remove('thecolselected')
        }
      }

      var btngroups = document.querySelectorAll('.my-btn-group')
      for (let k = 0; k < btngroups.length; k++) {
        btngroups[k].classList.add('inactive')
      }

      var handle = document.querySelectorAll('.the-handle')

      if (handle.length > 0) {
        for (var j = 0; j < handle.length; j++) {
          handle[j].classList.remove('show')
        }
      }

      var topAction = document.querySelectorAll('.top-action')

      if (document.getElementById('col-' + this.conIndex + '-' + colIndex).querySelector('.top-action')) {
        document.getElementById('col-' + this.conIndex + '-' + colIndex).querySelector('.top-action').classList.add('d-none')
      }

      var forImage = document.getElementById('col-' + this.conIndex + '-' + colIndex).querySelectorAll('.for-image')

      for (var i = 0; i < forImage.length; i++) {
        forImage[i].classList.remove('d-none')
      }

      document.getElementById('col-' + this.conIndex + '-' + colIndex).classList.add('columnActive')
      document.getElementById('col-' + this.conIndex + '-' + colIndex).closest('[role="conteneur"]').querySelector('.for-container').classList.add('d-none')
      document.getElementById('col-' + this.conIndex + '-' + colIndex).classList.remove('temp-col-deselect')
      document.getElementById('col-' + this.conIndex + '-' + colIndex).closest('[role="conteneur"]').querySelector('.top-action').classList.remove('d-none')
      // document.getElementById('col-' + this.conIndex + '-' + colIndex).closest('[role="conteneur"]').querySelector('.my-btn-group').classList.remove('inactive')
      document.getElementById('col-' + this.conIndex + '-' + colIndex).closest('[role="conteneur"]').querySelector('.my-btn-group').classList.remove('d-none')
      document.getElementById('control-' + this.conIndex + '-' + colIndex).classList.remove('d-none')

      if (document.querySelector('.temp-col-deselect')) {
        document.querySelector('.temp-col-deselect').classList.remove('temp-col-deselect')
      }

      if (document.querySelector('.thecolselected') === null) {
        if (document.querySelector('.temp-bloc-deselect')) {
          document.querySelector('.temp-bloc-deselect').classList.remove('temp-bloc-deselect')
        }
      }

      eventBus.$emit('enableToolbarButtons')

      setTimeout(() => {
        eventBus.$emit('selected', {
          containerId: this.conIndex,
          columnIndex: colIndex,
          element: this.colData,
          type: 'colonne'
        })
      }, 100)
    },
    deleteColonne () {
      this.deleteFicheColonne({conindex: this.conIndex, colindex: this.colIndex})
    },
    handleWrapperUpdate (data) {
      this.updateColonne({conindex: data.containerIndex, colindex: data.colIndex, data: data.data})
    },
    openEditWrapperModal (data) {
      this.$refs['editColWrapper'].open(data)
    },
    handleResizeCol (size) {
      this.resizeFicheColonne({conindex: this.conIndex, colindex: this.colIndex, size})
      this.showColonneSize = false
    },
    openElementSelectionModal () {
      this.$refs['selectionElement'].open()
    },
    handleAddElement (type) {
      this.addFicheColonneElement({conindex: this.conIndex, colindex: this.colIndex, type})
    },
    handleTextEdit (data) {
      this.editFicheColonneTextElement({conindex: this.conIndex, colindex: this.colIndex, ...data})
    },
    handleDeleteElement (elindex) {
      this.deleteFicheColonneTextElement({conindex: this.conIndex, colindex: this.colIndex, elindex})
    },
    handleDropEdit (data) {
      this.editFicheColonneDropElement({conindex: this.conIndex, colindex: this.colIndex, ...data})
    },
    handleUpdateData (data) {
      this.setAddedToFiche(data)
    }
  }
}
</script>
<style lang='scss' scoped>

    .container-controls {
        position:absolute;
        left: -35px;
        z-index: 1;
    }
    .container-controls ul {
        padding:0;
        margin:0;
    }
    .container-controls li {
        display:block;
        margin:-3px;
    }

    .container-controls li button {
        background:#9395C1;
        padding: 0 5px;
        font-size:11px;
        color:#fff;
        border-radius:0;
        width:35px;
    }

    .container-controls li button div {
        text-align:center;
        line-height: 20px;
        border-radius:0;
    }

    .columnActive {
        /*border:2px solid #9395C1;*/
        box-shadow: 0 0 2px 3px #9395C1;
    }

    .columnActive .inactive {
        background: #9395C1 !important;
    }

    .columnActive .container-controls {
        display:block !important;
    }
  .row[role="colonne"] div {
    padding-left: 0;
    padding-right: 0;
  }
  .btn-group {
    padding: 2px;
    background: #9395C1;
  }
  .btn-group.inactive {
    background: #7F7F7F;
  }
  .columnActive .inactive {
      display:block !important;
  }
  .header-action:hover {
      opacity:1;
      z-index:1;
  }
  .temp-deselect, .temp-col-deselect, .temp-bloc-deselect  {
      box-shadow: none;
      border:1px solid #ccc;
  }
    .temp-deselect .container-controls button,
    .temp-col-deselect .container-controls button,
    .temp-bloc-deselect .container-controls button{
        background: #ccc;
    }
  .header-action {
    position: absolute;
    top: 0;
      opacity:0.3;
    right: 0px;
    z-index:1;
    height: 25px;
    text-align: center;
    /*width: 100%;*/
    button{
      background-color: transparent;
      border: none;
      color: #fff;
      border-radius: 0;
      font-weight: normal;
      box-shadow: none !important;
      padding-left: 5px;
      padding-right: 5px;
      height: 25px;
      line-height: 25px;
      margin-top: -2px;
      &:hover{
        color: #2b3085;
      }
      &:active{
        background-color: #2b3085;
        color: #fff;
      }
    }
  }

  .colonne:empty {
    padding: 46px 26px 26px;
  }
  .move-action{
    cursor: move !important;
  }

    .container-active .top-level-col  {
        border:1px solid #ccc;
    }

  .colonne {
    /*border: 1px solid #CCC;*/
    /*padding: 46px 26px 26px;*/
    margin: 0 0;
    margin-bottom:0;
    position: relative;
    .add-element{
      width: 100%;
      border: 1px dashed #2b3085;
      padding: 13px 0;
      color: #2b3085;
      text-align: center;
      background-color: white;
      &:hover{
        color: #2b3085;
        border-color: #2b3085;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ficheEspace/edit/colonne.vue